var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.85 10.46C20.9495 10.8182 21 11.1882 21 11.56V19C21 19.5523 20.5523 20 20 20H19C18.4477 20 18 19.5523 18 19V18H6V19C6 19.5523 5.55228 20 5 20H4C3.44772 20 3 19.5523 3 19V11.56C2.99911 11.1849 3.04958 10.8114 3.15 10.45L4.59 5.45C4.83313 4.59977 5.60575 4.01014 6.49 4H17.49C18.3845 4.00256 19.1685 4.59874 19.41 5.46L20.85 10.46ZM6.51 5.75C6.39889 5.75 6.30111 5.82333 6.27 5.93L5.11 10H18.89L17.75 5.93C17.7189 5.82333 17.6211 5.75 17.51 5.75H6.51ZM8 14C8 14.5523 7.55228 15 7 15H6C5.44772 15 5 14.5523 5 14V13C5 12.4477 5.44772 12 6 12H7C7.55228 12 8 12.4477 8 13V14ZM18 15C18.5523 15 19 14.5523 19 14V13C19 12.4477 18.5523 12 18 12H17C16.4477 12 16 12.4477 16 13V14C16 14.5523 16.4477 15 17 15H18Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/car.0cf9ea15.svg";
export { ForwardRef as ReactComponent };